var _style, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFDA44;}\n\t.st1{fill:#338AF3;}\n\t.st2{fill:#6DA544;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378.4,31.1C342.1,11.3,300.4,0,256,0s-86.1,11.3-122.4,31.1L111.3,256l22.3,224.9 C169.9,500.7,211.6,512,256,512s86.1-11.3,122.4-31.1L400.7,256L378.4,31.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.6,480.9V31.1C54,74.5,0,159,0,256S54,437.5,133.6,480.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M512,256c0-97-54-181.5-133.6-224.9v449.7C458,437.5,512,353,512,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.3,322.8L155.8,256l44.5-66.8l44.5,66.8L200.3,322.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M311.7,322.8L267.1,256l44.5-66.8l44.5,66.8L311.7,322.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,411.8L211.5,345l44.5-66.8l44.5,66.8L256,411.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVc);
export default __webpack_public_path__ + "static/media/vc.138807bca4d87f3d1c922ec11ccacc5c.svg";
export { ForwardRef as ReactComponent };